import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route } from 'react-router';
import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import rootSaga from './sagas';
import createRootReducer from './reducers';
import { getRoutes } from './routes';
import App from './App';
import { createBrowserHistory } from 'history';
import HttpsRedirect from './components/auth/HttpsRedirect';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import 'flexboxgrid/dist/flexboxgrid.min.css';
import './styles/index.css';
import { setRumGlobalContext } from '@defi/core-utils';
import { datadogRum } from '@datadog/browser-rum';

var getEnv = function () {
  var regex = /\.(.*)\.(defisolutions|defiapps).com/;
  var envMatch = window.location.host.match(regex);
  if (!envMatch) return 'prod';
  else return envMatch[1];
};

const getEnableV3Ui = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const raw = window.localStorage.getItem('EnableV3Ui');
    if (raw === null) return false;
    if (raw === 'true' || raw === '1') return true;
    if (raw === 'false' || raw === '0') return false;
    try {
      return JSON.parse(raw) === true;
    } catch (e) {
      return false;
    }
  } catch (e) {
    return false;
  }
};

const enableV3Ui = getEnableV3Ui();

if (enableV3Ui) {
  import('./los-ui-v3/css/main.css');
}

var isLocalHost = /^(localhost|127\.0\.0\.1|dev\.defisolutions\.com)$/.test(window.location.hostname);

const env = getEnv();
if (env !== 'localdev' && !isLocalHost && process.env.NODE_ENV !== 'development') {
  datadogRum.init({
    applicationId: '714d1bcc-3aed-4186-b04e-d9690bf8b029',
    clientToken: 'pub127ada0635951daaf22f4a47012706fe',
    site: 'datadoghq.com',
    service: 'defi-ui',
    env,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    trackInteractions: false,
  });
}

datadogRum.onReady(function () {
  setRumGlobalContext(datadogRum, {
    ui_version: enableV3Ui ? 'v3' : 'v2',
    app_theme: document.documentElement.getAttribute('app-theme') || 'light',
    app_size: document.documentElement.getAttribute('app-size') || 'compact',
  });
});

const customHistory = createBrowserHistory({
  basename: '',
});

const sagaMiddleware = createSagaMiddleware();
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  createRootReducer(customHistory),
  composeEnhancer(applyMiddleware(sagaMiddleware, routerMiddleware(customHistory)))
);

const AppContext = React.createContext();
sagaMiddleware.run(rootSaga);

class Main extends Component {
  render() {
    return (
      <Provider store={store} context={AppContext}>
        <ConnectedRouter
          basename=""
          onUpdate={() => window.scrollTo(0, 0)}
          history={customHistory}
          context={AppContext}
        >
          <HttpsRedirect>
            <App history={customHistory} context={AppContext}>
              <Switch>
                {getRoutes.map(({ path, form, content: ContentComponent }) => (
                  <Route
                    location={customHistory.location}
                    key={path}
                    exact
                    form={form}
                    path={path}
                    render={(props) => <ContentComponent context={AppContext} {...props} />}
                  />
                ))}
              </Switch>
            </App>
          </HttpsRedirect>
        </ConnectedRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<Main />, document.getElementById('root'));
